export default __webpack_public_path__ + "static/media/plus.52ec1cf3.svg";